const language = {
    quizApplication: "Quiz Anwendung",
    submit: "Einreichen",
    nextQuestion: "Nächste Frage",
    finishQuiz: "Quiz Beenden",
    correct: "Richtig!",
    incorrect: "Falsch.",
    allCategories: "Alle Kategorien",
    selectSport: "Wählen Sie eine Sportart",
    handball: "Handball",
    soccer: "Fußball",
    answeredQuestions: "Beantwortete Fragen",
    correctAnswers: "Richtige Antworten",
    wrongAnswers: "Falsche Antworten",
    statistics: "Statistik",
    restartQuiz: "Quiz neu starten",
    userManagement: "Benutzerverwaltung",
    enterUserName: "Benutzernamen eingeben",
    addUser: "Benutzer hinzufügen",
    selectUser: "Benutzer auswählen",
    configureSports: "Sportarten konfigurieren",
    updateSports: "Sportarten aktualisieren",
    login: "Anmelden",
    logout: "Abmelden",
    enterPassword: "Passwort eingeben",
    enterCredentials: "Bitte Benutzernamen und Passwort eingeben",
    invalidCredentials: "Ungültige Anmeldedaten"
};

export default language;